module.exports = __webpack_public_path__ + "img/calapan-medical.8070dc74.jpg";